import { useToast } from "components/foundation/Toast";
import { useNavigate } from "react-router-dom";
import { useRemoveTempDocumentMutation } from "../mutations/useRemoveTempDocumentMutation";
import { ROUTER_PATH } from "config/path";

const useRemoveTempDoc = ({
  tempDocumentUuid,
  setBeforeUnloadDisable,
}: {
  tempDocumentUuid?: string;
  setBeforeUnloadDisable: (disable: boolean) => void;
}) => {
  const navigate = useNavigate();

  const removeTempDocumentMutation = useRemoveTempDocumentMutation();

  // 임시 저장 삭제 토스트
  const {
    open: openRemoveTempDocToast,
    onOpenToast: onOpenRemoveTempDocToast,
    onOpenChange: onOpenChangeRemoveTempDocToast,
  } = useToast();

  /**
   * @description 임시저장 삭제 버튼 클릭 이벤트 핸들러
   */
  const onClickRemoveTempDoc = () => {
    if (!tempDocumentUuid) return;

    removeTempDocumentMutation.mutate(tempDocumentUuid, {
      onSuccess: () => {
        onOpenRemoveTempDocToast(() => {
          setBeforeUnloadDisable(true);
          navigate(ROUTER_PATH.home);
        });
      },
    });
  };

  return {
    openRemoveTempDocToast,
    onOpenChangeRemoveTempDocToast,

    onClickRemoveTempDoc,
  };
};

export default useRemoveTempDoc;
